// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__H51NL","upload":"Small_upload__230mp","imageWrap":"Small_imageWrap__98uZQ","removeBtn":"Small_removeBtn__16aO9"};